import type { AuditLog } from '@/types/manifest';
import { formatToEST } from '@/lib/utils/date-format';

interface AuditLogsTableProps {
  logs: AuditLog[];
}

const actionLabels: Record<string, string> = {
  DeleteBarcode: 'Deleted Barcode',
  DeleteScan: 'Deleted Scan',
};

const actionColors: Record<string, string> = {
  DeleteBarcode: 'text-red-400',
  DeleteScan: 'text-orange-400',
};

export function AuditLogsTable({ logs }: AuditLogsTableProps) {
  if (logs.length === 0) {
    return (
      <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
        <h3 className="text-lg font-semibold mb-4">Admin Activity Log</h3>
        <p className="text-gray-400 text-sm">No admin actions recorded for this manifest.</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
      <h3 className="text-lg font-semibold mb-4">Admin Activity Log ({logs.length})</h3>
      <div className="space-y-3">
        {logs.map((log) => (
          <div
            key={log.id}
            className="flex items-start justify-between py-3 px-4 bg-gray-900/50 rounded border border-gray-700"
          >
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-1">
                <span className={`font-semibold ${actionColors[log.action] || 'text-gray-300'}`}>
                  {actionLabels[log.action] || log.action}
                </span>
                <span className="text-gray-500 text-sm">by {log.userName}</span>
              </div>
              <p className="text-sm text-gray-400">{log.details}</p>
              <p className="text-xs text-gray-500 mt-1">{formatToEST(log.timestamp, true)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
